/**
 * @module store/user/heslpers
 *
 * @version 1.0.0
 * @copyright SBC 2019
 */


import { Auth } from 'aws-amplify';
import jwtDecode from 'jwt-decode';


/**
 * Функция проверки, является ли пользователь админом
 *
 * @since 1.0.0
 */
const isUserAdmin = async (user) => {
  try {
    const userSession = await Auth.userSession(user);
    const token = jwtDecode(userSession.getAccessToken().getJwtToken());
    return token['cognito:groups'] && token['cognito:groups'].includes('Admins');
  } catch (error) {
    console.log(error);
    return false;
  }
};

export default isUserAdmin;
